(() => {
  if (customElements.get('announcement-bar-tools')) return;

  class AnnouncementBarTools extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.announcementBar = this.closest('.announcement-bar');
      this.handleClick = this.handleClick.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleFocusOut = this.handleFocusOut.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.setClearance = this.setClearance.bind(this);

      this.addEventListener('click', this.handleClick);
      this.addEventListener('focusout', this.handleFocusOut);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('click', this.handleDocumentClick);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.setClearance);
        this.querySelectorAll('.announcement-bar__desktop-tool').forEach((tool) => {
          this.resizeObserver.observe(tool);
        });
      } else {
        window.addEventListener('resize', this.setClearance);
      }

      this.setClearance();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('focusout', this.handleFocusOut);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('click', this.handleDocumentClick);
      window.removeEventListener('resize', this.setClearance);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      this.initialized = false;
    }

    handleClick(event) {
      const option = event.target.closest('[data-disclosure-option]');

      if (option && this.contains(option)) {
        event.preventDefault();

        const disclosure = option.closest('[data-disclosure]');
        const input = disclosure.querySelector('[data-disclosure-input]');
        const form = disclosure.closest('form');

        input.value = option.dataset.value;
        this.closeAllDisclosures();
        form.submit();
        return;
      }

      const toggle = event.target.closest('[data-disclosure-toggle]');

      if (!toggle || !this.contains(toggle)) return;

      const disclosure = toggle.closest('[data-disclosure]');
      const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';

      this.closeAllDisclosures(disclosure);
      this.setDisclosureState(disclosure, shouldOpen);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) this.closeAllDisclosures();
    }

    handleFocusOut(event) {
      const disclosure = event.target.closest('[data-disclosure]');

      requestAnimationFrame(() => {
        if (disclosure && !disclosure.contains(document.activeElement)) {
          this.setDisclosureState(disclosure, false);
        } else if (!this.contains(document.activeElement)) {
          this.closeAllDisclosures();
        }
      });
    }

    handleKeydown(event) {
      if (event.key !== 'Escape') return;

      const openToggle = this.querySelector('[data-disclosure-toggle][aria-expanded="true"]');
      const openDisclosure = openToggle ? openToggle.closest('[data-disclosure]') : null;

      if (!openDisclosure) return;

      const toggle = openDisclosure.querySelector('[data-disclosure-toggle]');
      this.setDisclosureState(openDisclosure, false);
      toggle.focus();
    }

    setDisclosureState(disclosure, isOpen) {
      disclosure.querySelector('[data-disclosure-toggle]').setAttribute('aria-expanded', String(isOpen));
      disclosure.querySelector('[data-disclosure-list]').setAttribute('aria-hidden', String(!isOpen));
    }

    closeAllDisclosures(exception) {
      this.querySelectorAll('[data-disclosure]').forEach((disclosure) => {
        if (disclosure !== exception) this.setDisclosureState(disclosure, false);
      });
    }

    setClearance() {
      if (!this.announcementBar) return;

      const widths = Array.from(this.querySelectorAll('.announcement-bar__desktop-tool'), (tool) =>
        tool.getBoundingClientRect().width
      );
      const widestTool = widths.length ? Math.max(...widths) : 0;

      this.announcementBar.style.setProperty(
        '--announcement-desktop-tool-clearance',
        `${Math.ceil(widestTool + 32)}px`
      );
    }
  }

  customElements.define('announcement-bar-tools', AnnouncementBarTools);
})();
